import script from "./DashboardSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardSkeleton.vue?vue&type=style&index=0&id=05f810a8&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05f810a8"]])

export default __exports__